import { render, staticRenderFns } from "./RecommendationsTokenPill.vue?vue&type=template&id=235a1f91"
import script from "./RecommendationsTokenPill.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationsTokenPill.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports